import { createContext } from 'react';

import * as graphql from '@treams/treams-network';

interface ICurrentlyViewedUserContext {
	currentlyViewedUser: graphql.User;
}

const CurrentlyViewedUserContext = createContext<ICurrentlyViewedUserContext | null>(null);

export default CurrentlyViewedUserContext;
